<template>
	<div class="page">
		<HeaderBar title="合并用药"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group title="">
					<van-row>
						<StaticSingleSelect label="合并用药" :selectkey.sync="form.bq420.Bq420_002" :list="existList" />
					</van-row>
					<van-row v-show="form.bq420.Bq420_002 == '有'">
						<van-cell-group :title="ywtype[index]" v-for="(item,index) in ywdataList" :key="index">
							
							<FormNormalInput label="药物名称" v-model="item.Bq420_003" />
							<FormNormalInput label="用法用量" v-model="item.Bq420_004" />
						</van-cell-group>
						<van-row style="display: flex; justify-content:space-between; margin: 2rem;">
							<van-button plain  block type="info" icon="plus" @click="ywdataList.push({ Bq420_003: '', Bq420_004: '' })" style="width: 50px;" size="small"></van-button>
							<van-button plain  block type="danger" icon="cross" @click="ywdataList.pop()" style="width: 50px;" size="small"></van-button>							
						</van-row>
					</van-row>
				</van-cell-group>
				<FormNormalUpload label="查看报告" ref="normalUpload" :infoGuid='form.bq420.guid' v-show="false">
				</FormNormalUpload>
				<div class="page-bottom-box" style="margin: 16px;" v-show='!savestate && bq400.Bq400_996 == "0"'>
					<SaveButton :url="saveUrl" ref="btnSave" back="0" @saveSucess="saveSucess"
						:editMode="form.bq420.guid != ''" class="hide">保存
					</SaveButton>
					<van-button block type="info" @click="SaveInfo">保存</van-button>
				</div>
				<div class="page-bottom-box" style="margin: 16px;" v-show='savestate'>
					<van-button block type="info">提交中……</van-button>
				</div>
			</van-form>
		</div>
	</div>
</template>

<script>
// 引入服务组件
import componentsModel from '../../../base/components.js'
// 引入子页面的混入对象
import mixinModel from '../mixins/mixins.js'
export default {
	name: "page014",
	mixins: [mixinModel],
	data() {
		return {
			modelname: 'bq420',
			form: {
				bq420: {
					id: "0", //编号
					guid: "", //guid编号
					companyGuid: "", //单位编号
					departmentGuid: "", //部门编号
					checkStatus: "", //审核状态
					dataStatus: "", //数据状态
					addUid: "", //添加人编号
					addTime: "", //添加时间					
					Bq400_guid: '', //随访基本信息表编号
					Bq420_002: '无', //
					Bq420_003: '', //
					Bq420_004: '', //
				},
				sempFiles: []
			},
			fullscreenLoading: false,
			//保存接口
			saveUrl: this.$utils.Url.s400 + '/api/S400Bq420/Save',
			ywdataList: [{ Bq420_003: '', Bq420_004: '' }],
			existList: [],
			bq400: JSON.parse(sessionStorage.getItem('bq400')),
			savestate: false,
			ywtype:['药物一','药物二','药物三','药物四','药物五','药物六','药物七','药物八','药物九','药物十']
		}
	},
	components: {
		...componentsModel
	},
	methods: {
		//加载信息
		LoadInfo: function () {
			var that = this
			var args = {
				bq400guid: this.bq400.guid
			}
			that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq420/Info', args, function (d) {
				let dataModel = d.Data
				if (dataModel != null) {
					that.$utils.CopyKeyInfo(dataModel, dataModel)
					that.$set(that.form, "bq420", dataModel)
				}
				let bq003 = that.form.bq420.Bq420_003.split('@@')
				let bq004 = that.form.bq420.Bq420_004.split('@@')
				that.ywdataList=[]
				bq003.forEach((item, index) => {
					that.ywdataList.push({ Bq420_003: item, Bq420_004: bq004[index] })
				})
			}, null, null, null);
		},

		//保存信息
		SaveInfo: function () {
			let that = this
			if(that.form.bq420.Bq420_002=='有'){
				if(that.ywdataList.length==0){
					that.$toast('请添加药物')
					return	
				}
			}
			//遍历药物，如果药物名称为空就提示不能为空
			for(let i=0;i<that.ywdataList.length;i++){
				if(that.ywdataList[i].Bq420_003==''){
					that.$toast('请添加药物名称')
					return
				}	
			}

			//将that.ywdataList中的Bq420_003合并成一个字符串，用@@分隔
			that.form.bq420.Bq420_003 = that.ywdataList.map(item => item.Bq420_003).join('@@')
			//将that.ywdataList中的Bq420_004合并成一个字符串，用@@分隔	
			that.form.bq420.Bq420_004 = that.ywdataList.map(item => item.Bq420_004).join('@@')

			that.form.sempFiles = that.$refs.normalUpload.GetFileList()
			that.$refs.btnSave.Save()
		},
	},
	mounted() {
		this.form.bq420.Bq400_guid = this.bq400.guid
		this.existList = this.$utils.setStandardList(this.$apis.s400Apis.existList)
		this.LoadInfo()
	}
}
</script>

<style scoped>
.unit {
	padding-top: 0.5rem;
	color: #999;
	font-size: 0.9em;
}
</style>
